module.exports = (parcelRequire.load("gz3cV")).then(() => parcelRequire('aeX8T'));